import { IconButton } from '@mui/material';
import type { ChildCustomerOverview } from '@weft/types';
import { fromNullToUndefined } from '@weft/utils';
import { Input } from 'apps/app/src/components/design/Input';
import { TrashIcon } from 'apps/app/src/components/icons/TrashIcon';

type CustomerInfoViewEditChildrenItemProps = {
  customerName: string;
  customerChild: ChildCustomerOverview;
  handleDeleteChild: () => void;
  isInEditMode: boolean;
};

export const CustomerInfoViewEditChildrenItem: React.FC<CustomerInfoViewEditChildrenItemProps> = ({ customerChild, isInEditMode, handleDeleteChild, customerName }) => {
  return (
    <div
      className='flex'
    >
      <div className="flex w-2/5 flex-col border-0 pr-6">
        <Input
          disabled
          editMode
          editModeOverride
          className='bg-white'
          value={customerChild.name}
          label='Name'
        />
      </div>

      <div className="flex w-3/12 flex-col border-0 pr-6">
        <Input
          disabled
          editMode
          editModeOverride
          className='bg-white'
          value={fromNullToUndefined(customerChild.externalId)}
          label='External ID'
        />
      </div>
      <div className="flex w-3/12 flex-col border-0 pr-6">
        <Input
          disabled
          editMode
          editModeOverride
          className='bg-white'
          value={`Aggregate to ${customerName}`}
          label='Invoice prefrences'
        />
      </div>
      <div className="flex grow -translate-x-4 flex-col items-end justify-end">
        <IconButton
          disabled={!isInEditMode}
          onClick={handleDeleteChild}
          className='disabled:invisible'
        >
          <TrashIcon className='fill-icon'/>
        </IconButton>
      </div>
    </div>
  );
};